<template>
  <v-container fluid grid-list-xl>
    <v-row class="first-row">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Messages</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text v-if="messages.items.length == 0"
            >Non sono presenti messaggi</v-card-text
          >

          <v-container>
            <v-row justify="space-between">
              <v-col md="4">
                <v-list two-line class="mr-x-0">
                  <v-list-item-group
                    v-model="messages.selected"
                    active-class="primary--text"
                  >
                    <template v-for="(item, index) in messages.items">
                      <v-list-item :key="item.index">
                        <template v-slot:default="{ active, toggle }">
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.object"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              class="text--primary"
                              v-text="item.first_name + ' ' + item.last_name"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle
                              v-if="item.clients.length > 0"
                              class="text--primary"
                              v-text="'Client: ' + item.clients[0].name"
                            ></v-list-item-subtitle>
                             <v-list-item-subtitle
                              v-if="item.merchants.length > 0"
                              class="text--primary"
                              v-text="'Merchant: ' + item.merchants[0].name"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle
                              v-text="item.content"
                            ></v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-list-item-action-text
                              v-text="moment(item.date_creation, 'YYYY-MM-DD')"
                            ></v-list-item-action-text>
                            <v-icon v-if="!active" color="grey lighten-1"
                              >mdi-check-circle-outline</v-icon
                            >

                            <v-icon v-else color="pink"
                              >mdi-check-circle</v-icon
                            >
                          </v-list-item-action>
                        </template>
                      </v-list-item>

                      <v-divider
                        v-if="index + 1 < messages.items.length"
                        :key="index"
                      ></v-divider>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col>
                <v-card flat md="12" v-if="messages.items.length > 0">
                  <v-card-title>{{
                    messages.items[messages.selected].object || ""
                  }}</v-card-title>
                  <v-card-title>{{
                    messages.items[messages.selected].creator || ""
                  }}</v-card-title>
                  <v-card-text>{{
                    messages.items[messages.selected].content || ""
                  }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiService from '@/services'
import moment from 'moment'

// const apiService = new ApiService();

export default {
  data () {
    return {
      messages: {
        selected: 0,
        items: []
      },
      // Total donations table
      donationAmountTable: {
        tableSearch: '',
        searchTimeout: null,
        // Donations csv file
        donationsCsv: '',
        // Table loading state
        loading: true,
        // Headers
        tableHeaders: [
          { text: 'Nome NPO', value: 'name' },
          { text: 'Codice fiscale', value: 'npofc' },
          { text: 'Totale', value: 'amount' }
        ],
        totalData: 0,
        tableData: [],
        options: {}
      },

      // Events tab
      events: {
        eventList: [],
        tabs: 0,
        loading: 0
      }
    }
  },
  filters: {
    moment: function (date) {
      return moment.format('DD MM YYYY, h:mm:ss')
    }
  },
  watch: {
    options: {
      handler () {
        // this.getTotalDonations()
      },
      deep: true
    }
  },
  mounted () {
    this.getMessages()
  },
  methods: {
    getMessages () {
      apiService
        .getMessages()
        .then((response) => {
          this.messages.items = response
        })
        .catch((error) => {
          console.log(error)
        })
    },
    moment: function (date) {
      return moment.unix(date).format('DD MM YYYY, h:mm:ss')
    },
    // Upload file su variabile del componente
    fileUpload () {
      console.log(this.$refs.file)
      this.file = this.$refs.file.lazyValue
    },
    // Upload del file su BE csv/json
    submitFile () {
      console.log('submitFile')
      let formData = new FormData()
      if (this.file.name) {
        console.log('Uploading CSV...')
        formData.append('file', this.file)
        apiService.upload(formData)
      }
    },
    // GET delle donazioni
    // To Do aggiungere ricerca e date
    getTotalDonations () {
      console.log('getTotalDonations')
      this.donationAmountTable.loading = true
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage,
        searchValue
      } = this.donationAmountTable.options
      let filter = {}
      filter.orderBy = sortBy[0] || 'amount'
      filter.orderDesc = sortDesc[0] || true
      filter.page = page
      filter.itemsPerPage = itemsPerPage
      filter.searchValue = searchValue

      console.log(filter)
      apiService.getTotalDonations(filter).then((response) => {
        this.donationAmountTable.tableData = response.results
        this.donationAmountTable.totalData = response.count
        setTimeout(() => {
          this.donationAmountTable.loading = false
        }, 500)
      })
    },
    searchDonations (value) {
      this.donationAmountTable.options.searchValue = value
      clearTimeout(this.donationAmountTable.searchTimeout)
      this.donationAmountTable.searchTimeout = setTimeout(() => {
        this.getTotalDonations()
      }, 1000)
    },
    goToNpo (item) {
      this.$router.push({
        path: 'npos/' + item.npofc,
        params: { fiscalCode: item.npofc }
      })
    },
    getEvents () {
      this.loading = true
      apiService.fetchData('events').then((response) => {
        for (let n in response) {
          this.events.eventList.push({
            icon: 'mdi-folder',
            iconClass: 'grey lighten-1 white--text',
            title:
              '' +
              response[n].user +
              ' ' +
              response[n].event +
              ' ' +
              response[n].resouce +
              ' ' +
              response[n].resouceId,
            subtitle: response[n].date,
            resource: response[n].resource
          })
        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    }
  }
}
</script>
<style scoped>
.first-row {
  height: 500px;
}
.message-list {
  border-right: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 0;
  display: inline-grid;
}

.message {
  display: inline-grid;
}

.card-tabs {
  height: 417px;
}
</style>
